[
  { "countryCode": "AD", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "AE", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "AF", "validationCode": "POSTAL_CODE" },
  { "countryCode": "AG", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "AL", "validationCode": "POSTAL_CODE" },
  { "countryCode": "AM", "validationCode": "POSTAL_CODE" },
  { "countryCode": "AO", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "AR", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "AT", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "AU", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "AZ", "validationCode": "POSTAL_CODE" },
  { "countryCode": "BA", "validationCode": "POSTAL_CODE" },
  { "countryCode": "BB", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "BD", "validationCode": "POSTAL_CODE" },
  { "countryCode": "BE", "validationCode": "POSTAL_CODE" },
  { "countryCode": "BF", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "BG", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "BH", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "BI", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "BJ", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "BN", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "BO", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "BR", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "BS", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "BT", "validationCode": "POSTAL_CODE" },
  { "countryCode": "BW", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "BY", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "BZ", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "CA", "validationCode": "POSTAL_CODE" },
  { "countryCode": "CD", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "CF", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "CG", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "CH", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "CI", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "CL", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "CM", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "CN", "validationCode": "POSTAL_CODE" },
  { "countryCode": "CO", "validationCode": "POSTAL_CODE" },
  { "countryCode": "CR", "validationCode": "POSTAL_CODE" },
  { "countryCode": "CU", "validationCode": "POSTAL_CODE" },
  { "countryCode": "CV", "validationCode": "POSTAL_CODE" },
  { "countryCode": "CY", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "CZ", "validationCode": "POSTAL_CODE" },
  { "countryCode": "DE", "validationCode": "POSTAL_CODE" },
  { "countryCode": "DJ", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "DK", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "DM", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "DO", "validationCode": "POSTAL_CODE" },
  { "countryCode": "DZ", "validationCode": "POSTAL_CODE" },
  { "countryCode": "EC", "validationCode": "POSTAL_CODE" },
  { "countryCode": "EE", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "EG", "validationCode": "POSTAL_CODE" },
  { "countryCode": "ER", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "ES", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "ET", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "FI", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "FJ", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "FO", "validationCode": "POSTAL_CODE" },
  { "countryCode": "FR", "validationCode": "POSTAL_CODE" },
  { "countryCode": "GA", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "GB", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "GD", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "GE", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "GH", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "GL", "validationCode": "POSTAL_CODE" },
  { "countryCode": "GM", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "GN", "validationCode": "POSTAL_CODE" },
  { "countryCode": "GQ", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "GR", "validationCode": "POSTAL_CODE" },
  { "countryCode": "GT", "validationCode": "POSTAL_CODE" },
  { "countryCode": "GW", "validationCode": "POSTAL_CODE" },
  { "countryCode": "GY", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "HK", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "HN", "validationCode": "POSTAL_CODE" },
  { "countryCode": "HR", "validationCode": "POSTAL_CODE" },
  { "countryCode": "HT", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "HU", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "ID", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "IE", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "IL", "validationCode": "POSTAL_CODE" },
  { "countryCode": "IN", "validationCode": "POSTAL_CODE" },
  { "countryCode": "IQ", "validationCode": "POSTAL_CODE" },
  { "countryCode": "IR", "validationCode": "POSTAL_CODE" },
  { "countryCode": "IS", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "IT", "validationCode": "POSTAL_CODE" },
  { "countryCode": "JM", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "JO", "validationCode": "POSTAL_CODE" },
  { "countryCode": "JP", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "KE", "validationCode": "POSTAL_CODE" },
  { "countryCode": "KG", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "KH", "validationCode": "POSTAL_CODE" },
  { "countryCode": "KI", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "KM", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "KN", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "KP", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "KR", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "KW", "validationCode": "POSTAL_CODE" },
  { "countryCode": "KZ", "validationCode": "POSTAL_CODE" },
  { "countryCode": "LA", "validationCode": "POSTAL_CODE" },
  { "countryCode": "LB", "validationCode": "POSTAL_CODE" },
  { "countryCode": "LC", "validationCode": "POSTAL_CODE" },
  { "countryCode": "LI", "validationCode": "POSTAL_CODE" },
  { "countryCode": "LK", "validationCode": "POSTAL_CODE" },
  { "countryCode": "LR", "validationCode": "POSTAL_CODE" },
  { "countryCode": "LS", "validationCode": "POSTAL_CODE" },
  { "countryCode": "LT", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "LU", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "LV", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "LY", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "MA", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "MC", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "MD", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "ME", "validationCode": "POSTAL_CODE" },
  { "countryCode": "MG", "validationCode": "POSTAL_CODE" },
  { "countryCode": "MK", "validationCode": "POSTAL_CODE" },
  { "countryCode": "ML", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "MM", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "MN", "validationCode": "POSTAL_CODE" },
  { "countryCode": "MR", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "MT", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "MU", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "MV", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "MW", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "MX", "validationCode": "POSTAL_CODE" },
  { "countryCode": "MY", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "MZ", "validationCode": "POSTAL_CODE" },
  { "countryCode": "NA", "validationCode": "POSTAL_CODE" },
  { "countryCode": "NE", "validationCode": "POSTAL_CODE" },
  { "countryCode": "NG", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "NI", "validationCode": "POSTAL_CODE" },
  { "countryCode": "NL", "validationCode": "POSTAL_CODE" },
  { "countryCode": "NO", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "NR", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "NZ", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "OM", "validationCode": "POSTAL_CODE" },
  { "countryCode": "PA", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "PE", "validationCode": "POSTAL_CODE" },
  { "countryCode": "PG", "validationCode": "POSTAL_CODE" },
  { "countryCode": "PH", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "PK", "validationCode": "POSTAL_CODE" },
  { "countryCode": "PL", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "PT", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "PY", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "QA", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "RO", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "RS", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "RU", "validationCode": "POSTAL_CODE" },
  { "countryCode": "RW", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "SA", "validationCode": "POSTAL_CODE" },
  { "countryCode": "SB", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "SC", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "SD", "validationCode": "POSTAL_CODE" },
  { "countryCode": "SE", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "SG", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "SI", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "SK", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "SL", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "SM", "validationCode": "POSTAL_CODE" },
  { "countryCode": "SN", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "SO", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "SR", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "SS", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "ST", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "SV", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "SY", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "SZ", "validationCode": "POSTAL_CODE" },
  { "countryCode": "TD", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "TG", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "TH", "validationCode": "POSTAL_CODE" },
  { "countryCode": "TJ", "validationCode": "POSTAL_CODE" },
  { "countryCode": "TL", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "TM", "validationCode": "POSTAL_CODE" },
  { "countryCode": "TN", "validationCode": "POSTAL_CODE" },
  { "countryCode": "TO", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "TR", "validationCode": "POSTAL_CODE" },
  { "countryCode": "TT", "validationCode": "POSTAL_CODE" },
  { "countryCode": "TV", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "TZ", "validationCode": "POSTAL_CODE" },
  { "countryCode": "UA", "validationCode": "POSTAL_CODE" },
  { "countryCode": "UG", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "US", "validationCode": "POSTAL_CODE" },
  { "countryCode": "UY", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "UZ", "validationCode": "POSTAL_CODE" },
  { "countryCode": "VA", "validationCode": "POSTAL_CODE_AND_STREET" },
  { "countryCode": "VC", "validationCode": "POSTAL_CODE" },
  { "countryCode": "VE", "validationCode": "POSTAL_CODE" },
  { "countryCode": "VN", "validationCode": "POSTAL_CODE" },
  { "countryCode": "VU", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "WS", "validationCode": "POSTAL_CODE" },
  { "countryCode": "XK", "validationCode": "POSTAL_CODE" },
  { "countryCode": "YE", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "ZA", "validationCode": "POSTAL_CODE" },
  { "countryCode": "ZM", "validationCode": "COUNTRY_ONLY" },
  { "countryCode": "ZW", "validationCode": "COUNTRY_ONLY" }
]
